export enum RouteEnum {
    MY_COURSES = "my-courses",
    COURSE_CREATION = "course-creation",
    COURSE = "courses",
    CATEGORIES = "categories",
    CATEGORY_CREATION = "category-creation",
    LOGIN = "login",
    MEDIA_LIBRARY = "my-media-library",
    CHANGE_PASSWORD_LOGGED = "update-password-logged",
    EXPLORE = "explore",
    FAVORITE = "favorites",
    MY_NOTES = "my-notes",
    MANAGE_USERS = "manage-users",
    MANAGE_CLIENTS = "manage-clients",
    WEBHOOK = "webhooks",
    PERMISSION = "permissions",
    SHOPPING_CART = "shopping-cart",
	ACCOUNT_SETTINGS = "/account/settings",
	COURSE_DETAILS = "/course-details",
	ACCOUNT_SETTINGS_PASSWORD = "/account/settings/password",
	ACCOUNT_SETTINGS_PAYMENT_METHOD = "/account/settings/payment-method",
	ACCOUNT_SETTINGS_PURCHASE_HISTORY = "/account/settings/purchase-history",
	HOME = "/home",
	SALES = "sales",
	ORDER = "order",
	FORGOT_PASSWORD = 'forgot-password',
	CATEGORY_OVERVIEW = 'category-overview',
	LINK_EXPIRED = 'link-expired',
	SSO = 'sso',
    TERMS_AND_CONDITIONS = 'terms-and-conditions',
	ONLINE_USERS = 'online-users',
};
